module.exports = __webpack_public_path__ + "img/icon-reference.c90811f7.png";